import { debounce, triggerAPI } from 'modules/util';
const searchWrapper = sel('.docs-search'),
  searchQuery = sel('.search-input', searchWrapper),
  clearText = sel('.clear-text', searchWrapper),
  searchResWrapper = sel('.results', searchWrapper),
  fady = sel('.fady', searchWrapper),
  queryURL = 'https://search.razorpay.com/docs',
  config = {
    searchContainerHeight: '490px',
    waitTime: 400,
    smallDeviceWidth: 768,
    resultDescSliceLength: 170
  };

function sel(selector, parent = document) {
  return parent.querySelector(selector);
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function replaceHyphensWithSpaces(str) {
  return str.replaceAll('-', ' ');
}

function getBreadCrumb(url) {
  if (typeof url === 'string' || url instanceof String)
    return url
      .split('/')
      .map(path => {
        path = replaceHyphensWithSpaces(path);
        path = capitalize(path);
        return path;
      })
      .join(' > ');
  return '';
}

function showResultList(url, title, body) {
  const breadcrumb = getBreadCrumb(url);
  return `
        <div class="list-item">
          <a href="https://razorpay.com/docs/${url}">
            <div class="res-header">
              ${title}
            </div>
            <div class="res-breadcrumb">
              ${breadcrumb}
            </div>
            <div class="res-desc">
              ${
                body.length !== 0
                  ? body.slice(0, config.resultDescSliceLength) + '...'
                  : ''
              }
            </div>
          </a>
      </div>
  `;
}

function showNoResults() {
  return `
  <div class="list-item">
    <div class="res-header no-results">
      No results found for "${searchQuery.value}"
    </div>
    <div class="desc-desc">
      Try using complete words or use a comma to seperate multiple keywords if any.
    </div>
  </div>`;
}

function queryHandler() {
  searchQuery.value.length ? showClearIcon() : hideClearIcon();
  searchQuery.classList.add('focused');
  searchQuery.value.length &&
    triggerAPI(
      queryURL + '?q=' + encodeURIComponent(searchQuery.value),
      'GET',
      data => {
        if (data.length) {
          showResBlock();
          searchResWrapper.innerHTML = '';
          const Resp = JSON.parse(data);
          if (Resp.length) {
            Resp.map(res => {
              searchResWrapper.innerHTML += showResultList(
                res.url,
                res.title,
                res.body
              );
            });
            emitGAForResults('Displayed', searchQuery.value);
          } else {
            searchResWrapper.innerHTML = showNoResults();
            fady.style.display = 'none';
            emitGAForResults('Dismissted', searchQuery.value);
          }
        }
        data.length <= 3
          ? (fady.style.display = 'none')
          : (fady.style.display = 'block');
        data.length === 1 &&
          searchResWrapper.classList.add('overflow-y-disable');
      }
    );
  window.innerWidth <= config.smallDeviceWidth
    ? searchWrapper.scrollIntoView({ behavior: 'smooth' })
    : '';
}

function hideResBlock() {
  searchResWrapper.style.opacity = 0;
  fady.style.display = 'none';
}

function showResBlock() {
  searchResWrapper.style.opacity = 1;
  searchResWrapper.classList.add('drawer-open');
  searchResWrapper.style.maxHeight = config.searchContainerHeight;
}

function hideClearIcon() {
  clearText.style.visibility = 'hidden';
}

function showClearIcon() {
  clearText.style.visibility = 'visible';
}

function clearSearchQuery() {
  searchQuery.value = '';
  searchResWrapper.innerHTML = '';
  hideClearIcon();
  hideResBlock();
}

function hideSearchElement() {
  if (!searchQuery.classList.contains('focused')) {
    hideResBlock();
  }
}

searchQuery.addEventListener('blur', function() {
  searchQuery.classList.remove('focused');
  searchWrapper.classList.remove('focused');
});

clearText.addEventListener('click', clearSearchQuery);
document.addEventListener('click', hideSearchElement);
searchQuery.addEventListener('click', queryHandler);
searchQuery.addEventListener('keyup', debounce(queryHandler, config.waitTime));

function emitGAForResults(action, searchValue) {
  window.rzpAnalytics({
    eventCategory: 'Doc Search',
    eventAction: `Results ${action}`,
    eventLabel: `Query: ${searchValue ||
      'null'} | Current Page: https://razorpay.com/docs/`
  });
}
